@if (comment(); as comment) {
  <div class="tt-comment-card">
    @if (comment.type === CommentType.Comment) {
      <div class="tt-comment-card_review-label">
        {{ 'Comments.Review' | transloco }}
        @if (anchorThreadPosition(); as position) {
          <span class="tt-comment-card_anchor-position">{{ position.current }}/{{ position.total }}</span>
        }
      </div>
    }
    @if (comment.type === CommentType.ReaderFeedback) {
      <div class="tt-comment-card_feedback-label">
        {{ 'Comments.ReaderFeedback' | transloco }}
        @if (anchorThreadPosition(); as position) {
          <span class="tt-comment-card_anchor-position">{{ position.current }}/{{ position.total }}</span>
        }
      </div>
    }
    @if (comment.type === CommentType.PersonalNote) {
      <div class="tt-comment-card_note-label">
        {{ 'Comments.PersonalNote' | transloco }}
        @if (anchorThreadPosition(); as position) {
          <span class="tt-comment-card_anchor-position">{{ position.current }}/{{ position.total }}</span>
        }
      </div>
    }
    @if (originalContentUnavailable()) {
      <div class="tt-comment-card_unavailable-content">
        <mat-icon [icon]="'info'" [iconSize]="16" />
        {{ 'Comments.OriginalContentUnavailable' | transloco }}
      </div>
    }
    <tt-comment-card-comment
      [comment]="comment"
      [editMode]="editMode()"
      [path]="path()"
      [readonly]="comment.createdBy?.id !== currentUser().id || readonly()"
      (commentEdited)="commentEdited.emit($event)"
      (deleteComment)="handleDeleteComment(comment, $event)"
      (editModeChange)="editMode.set($event)"
      (resolveComment)="handleResolveComment($event)" />

    @if (comment.replies?.length > 0) {
      <button class="tt-comment-card_replies-toggle" (click)="showReplies.set(!showReplies())">
        <mat-icon [icon]="showReplies() ? 'chevron-down' : 'chevron-right'" [iconSize]="16" />
        {{ comment.replies.length }} {{ (comment.replies.length === 1 ? 'Comments.Reply' : 'Comments.Replies') | transloco }}
      </button>

      @if (showReplies()) {
        <div class="tt-comment-card_replies">
          @for (reply of comment.replies; track reply.id) {
            <tt-comment-card-comment
              [comment]="reply"
              [readonly]="reply.createdBy.id !== currentUser().id || readonly()"
              (commentEdited)="commentEdited.emit($event)"
              (deleteComment)="handleDeleteComment(reply, $event)" />
          }
        </div>
      }
    }

    @if (tempReply() !== undefined) {
      <common-rich-text-editor
        class="tt-comment-card_comment-text-editor"
        [focusOnInit]="true"
        [placeholder]="
          (comment.type === CommentType.PersonalNote ? 'Comments.EmptyPersonalNotePlaceholder' : 'Comments.EmptyCommentPlaceholder')
            | transloco
        "
        [toolbarType]="'basic'"
        [ttAutofocus]="true"
        [(editorContent)]="tempReply" />

      <div class="tt-comment-card_comment-text-actions">
        <button ttButton [variant]="'secondary'" (click)="tempReply.set(undefined)">{{ 'Cancel' | transloco }}</button>
        <button ttButton [variant]="'primary'" (click)="sendReply()">{{ 'Save' | transloco }}</button>
      </div>
    }

    @if (!!comment.createdAt && tempReply() === undefined && !editMode() && !readonly() && comment.type !== CommentType.PersonalNote) {
      <div class="tt-comment-card_comment-text-actions">
        @if (!comment.resolved) {
          <button ttButton [variant]="'transparent'" (click)="handleResolveComment()">{{ 'Comments.Resolve' | transloco }}</button>
        }

        <button ttButton [variant]="'transparent'" (click)="handleReplyComment()">{{ 'Comments.Reply' | transloco }}</button>
      </div>
    }
  </div>
}
